export default "__VITE_PUBLIC_ASSET__fdc74bc4__"